// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"c79abe45","342":"b9898fbd","384":"ba38d9a1","443":"6ff6cbff","787":"c1112931"}[chunkId] + ".chunk.js";
};